import { forwardRef, memo, SVGProps } from 'react'
import { chakra } from '@chakra-ui/react'

const MemoLogicSvgr = memo(
  forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      viewBox="0 0 292 232"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M186.378.923a.251.251 0 0 0-.476 0l-1.74 5.355h-5.63a.25.25 0 0 0-.147.452l4.555 3.31-1.74 5.355a.25.25 0 0 0 .385.28l4.555-3.31 4.555 3.31a.25.25 0 0 0 .385-.28l-1.74-5.355 4.556-3.31a.25.25 0 0 0-.147-.452h-5.631l-1.74-5.355ZM204.378.923a.251.251 0 0 0-.476 0l-1.74 5.355h-5.63a.25.25 0 0 0-.147.452l4.555 3.31-1.74 5.355a.25.25 0 0 0 .385.28l4.555-3.31 4.555 3.31a.25.25 0 0 0 .385-.28l-1.74-5.355 4.556-3.31a.25.25 0 0 0-.147-.452h-5.631l-1.74-5.355Z"
        fill="#445072"
        stroke="#445072"
        strokeWidth={0.5}
        strokeLinejoin="round"
      />
      <path
        d="M222.378.923a.251.251 0 0 0-.476 0l-1.74 5.355h-5.63a.25.25 0 0 0-.147.452l4.555 3.31-1.74 5.355a.25.25 0 0 0 .385.28l4.555-3.31 4.555 3.31a.25.25 0 0 0 .385-.28l-1.74-5.355 4.556-3.31a.25.25 0 0 0-.147-.452h-5.631l-1.74-5.355ZM185.937 18.923a.251.251 0 0 0-.476 0l-1.74 5.355h-5.63a.25.25 0 0 0-.147.452l4.555 3.31-1.74 5.355a.25.25 0 0 0 .385.28l4.555-3.31 4.555 3.31a.25.25 0 0 0 .385-.28l-1.74-5.355 4.555-3.31a.25.25 0 0 0-.147-.452h-5.63l-1.74-5.355ZM203.937 18.923a.251.251 0 0 0-.476 0l-1.74 5.355h-5.63a.25.25 0 0 0-.147.452l4.555 3.31-1.74 5.355a.25.25 0 0 0 .385.28l4.555-3.31 4.555 3.31a.25.25 0 0 0 .385-.28l-1.74-5.355 4.555-3.31a.25.25 0 0 0-.147-.452h-5.63l-1.74-5.355Z"
        stroke="#445072"
        strokeWidth={0.5}
        strokeLinejoin="round"
      />
      <path
        d="M85.188 12H58.14v27.048h27.048V12Z"
        stroke="#445072"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M81.151 18.56 67.173 32.538l-4.996-4.945"
        stroke="#445072"
        strokeWidth={3}
        strokeMiterlimit={10}
      />
      <path
        d="M263.101 81.653h-14.635c-4.592 0-8.326-3.735-8.326-8.327 0-4.592 3.734-8.326 8.326-8.326h14.635c4.592 0 8.326 3.734 8.326 8.326 0 4.592-3.734 8.327-8.326 8.327Z"
        stroke="#445072"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M262.848 79.23a5.904 5.904 0 1 0 0-11.807 5.904 5.904 0 0 0 0 11.808Z"
        fill="#445072"
      />
      <path
        d="M279.265 159.504V191H216.14v-31.496M291.301 147.067H216.14v12.304h75.161v-12.304ZM283.544 151.48l3.545 3.545M287.089 151.48l-3.545 3.545M279.332 147v12.17"
        stroke="#445072"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M222.626 167.127h44.201M222.626 153.152h24.14M222.626 175.286h24.14M222.626 183.443h36.177"
        stroke="#445072"
        strokeWidth={3.975}
        strokeMiterlimit={10}
      />
      <path
        d="m275.253 151.681-1.873 2.407-1.805-2.407h3.678Z"
        fill="#445072"
      />
      <path
        d="M7.14 88h25"
        stroke="#445072"
        strokeWidth={3.975}
        strokeMiterlimit={10}
      />
      <path
        d="M75.86 82.067H.699V94.37H75.86V82.067ZM72.382 88.252h-5.013M57.646 85.746v5.012M60.152 88.252H55.14"
        stroke="#445072"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M63.89 84v8"
        stroke="#DADCE3"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path stroke="#000" strokeWidth={0.5} d="M24.14 230.75h252" />
      <rect
        x={88.564}
        y={29.571}
        width={129.237}
        height={201.427}
        rx={8.17}
        fill="#F6F7FC"
      />
      <rect
        x={84.375}
        y={29.571}
        width={129.237}
        height={201.427}
        rx={8.17}
        fill="#4A61C0"
      />
      <rect
        x={88.564}
        y={29.571}
        width={129.237}
        height={201.427}
        rx={8.17}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={81.713}
        y={29.571}
        width={129.237}
        height={201.427}
        rx={8.17}
        fill="#F6F7FC"
      />
      <rect
        x={81.713}
        y={29.571}
        width={129.237}
        height={201.427}
        rx={8.17}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={96.14}
        y={44}
        width={100}
        height={44}
        rx={3.546}
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.464}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.464}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.034}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={176.034}
        y={108.009}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={131.544}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={131.544}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.461}
        y={131.542}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.461}
        y={131.542}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={131.542}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={131.542}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.461}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.461}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.034}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={176.034}
        y={155.076}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.461}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.461}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.034}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={176.034}
        y={178.611}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={175.83}
        y={108}
        width={11.857}
        height={34.831}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={108}
        width={10.834}
        height={34.37}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={175.83}
        y={155.27}
        width={11.857}
        height={34.09}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={155.076}
        width={10.834}
        height={34.37}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={202.146}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.8}
        y={202.146}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.464}
        y={202.146}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={129.464}
        y={202.146}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={202.146}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={153.126}
        y={202.146}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={202.146}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#000"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.788}
        y={202.146}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.043}
        y={108.004}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={128.707}
        y={108.004}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={152.369}
        y={108}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={105.043}
        y={131.54}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={128.707}
        y={131.54}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={152.369}
        y={131.54}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={105.043}
        y={155.071}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={128.707}
        y={155.071}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={152.369}
        y={155.071}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={105.043}
        y={178.608}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={128.707}
        y={178.608}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={152.369}
        y={178.608}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={176.031}
        y={108}
        width={10.834}
        height={34.37}
        rx={2.696}
        fill="#4A61C0"
      />
      <rect
        x={176.031}
        y={155.071}
        width={10.834}
        height={34.37}
        rx={2.696}
        fill="#4A61C0"
      />
      <rect
        x={105.043}
        y={202.144}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={128.707}
        y={202.144}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={152.369}
        y={202.144}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#F6F7FC"
      />
      <rect
        x={176.031}
        y={202.144}
        width={10.834}
        height={10.834}
        rx={2.696}
        fill="#4A61C0"
      />
      <rect
        x={105.043}
        y={108.004}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={128.707}
        y={108.004}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={152.369}
        y={108}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.043}
        y={131.537}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={128.707}
        y={131.537}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={152.369}
        y={131.537}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.043}
        y={155.075}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={128.707}
        y={155.075}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={152.369}
        y={155.075}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.043}
        y={178.606}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={128.707}
        y={178.606}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={152.369}
        y={178.606}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <path
        d="M176.031 110.696a2.696 2.696 0 0 1 2.696-2.696h5.442a2.696 2.696 0 0 1 2.696 2.696v28.977a2.697 2.697 0 0 1-2.696 2.697h-5.442a2.697 2.697 0 0 1-2.696-2.697v-28.977Z"
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.031}
        y={155.073}
        width={10.834}
        height={34.37}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={105.043}
        y={202.144}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={128.707}
        y={202.144}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={152.369}
        y={202.144}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <rect
        x={176.083}
        y={202.144}
        width={10.834}
        height={10.834}
        rx={2.696}
        stroke="#000"
        strokeWidth={0.5}
      />
      <path
        d="M125.696 49.25a2.38 2.38 0 0 1 2.38 2.38v10.746a2.38 2.38 0 0 1-2.38 2.38h-22.402a2.38 2.38 0 0 1-2.38-2.38V51.63a2.38 2.38 0 0 1 2.38-2.381h22.402Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
      />
      <path
        d="M112.392 54.578h-.616v5.09h.616v-5.09Zm1.236 5.09h.617v-2.276h2.207v-.547h-2.207v-1.72h2.436v-.547h-3.053v5.09Z"
        fill="#000"
      />
      <path
        d="M125.696 67.267a2.38 2.38 0 0 1 2.38 2.38v10.746a2.38 2.38 0 0 1-2.38 2.38h-22.402a2.38 2.38 0 0 1-2.38-2.38V69.648a2.38 2.38 0 0 1 2.38-2.38h22.402Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
      />
      <path
        d="M104.914 73.141h1.601v4.544h.617v-4.544h1.601v-.546h-3.819v.546Zm4.77 4.544h.617V75.41h2.714v2.276h.617v-5.09h-.617v2.267h-2.714v-2.267h-.617v5.09Zm5.182 0h3.112v-.546h-2.496v-1.73h2.297v-.547h-2.297v-1.72h2.456v-.547h-3.072v5.09Zm8.22-5.09h-.606v4.007h-.05l-2.784-4.007h-.597v5.09h.617v-3.997h.05l2.774 3.998h.596v-5.091Z"
        fill="#000"
      />
      <path
        d="M188.509 49.25a2.38 2.38 0 0 1 2.381 2.38v10.746a2.38 2.38 0 0 1-2.381 2.38h-55.738a2.38 2.38 0 0 1-2.381-2.38V51.63a2.38 2.38 0 0 1 2.381-2.381h55.738Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
      />
      <path
        d="M158.928 59.708a.45.45 0 0 0 .448-.447.448.448 0 1 0-.448.447Zm1.928 0a.448.448 0 0 0 0-.895.448.448 0 0 0 0 .895Zm1.928 0a.448.448 0 0 0 0-.895.45.45 0 0 0-.448.448.45.45 0 0 0 .448.447Z"
        fill="#000"
      />
      <path
        d="M188.509 67.267a2.38 2.38 0 0 1 2.381 2.38v10.746a2.38 2.38 0 0 1-2.381 2.38h-55.738a2.38 2.38 0 0 1-2.381-2.38V69.648a2.38 2.38 0 0 1 2.381-2.38h55.738Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
      />
      <path
        d="M158.928 77.725a.45.45 0 0 0 .448-.447.448.448 0 1 0-.448.447Zm1.928 0a.448.448 0 0 0 0-.895.448.448 0 0 0 0 .895Zm1.928 0a.448.448 0 0 0 0-.895.45.45 0 0 0-.448.448.45.45 0 0 0 .448.447Z"
        fill="#000"
      />
      <circle
        cx={43.14}
        cy={146}
        r={11.75}
        stroke="#445072"
        strokeWidth={0.5}
      />
      <circle
        cx={43.14}
        cy={146}
        r={7.75}
        fill="#445072"
        stroke="#445072"
        strokeWidth={0.5}
      />
    </svg>
  )),
)

export const LogicSvgr = chakra(MemoLogicSvgr)
